import React, { useState, useEffect } from "react";
import "./Header.css";

const Header = ({
  theme,
  toggleTheme,
  language,
  toggleLanguage,
  t,
  onNavigate,
}) => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    // Reset to home view if we're in blog view
    if (onNavigate) {
      onNavigate("home");
    }
    // Clear hash first, then set new hash
    window.location.hash = "";
    setTimeout(() => {
      window.location.hash = sectionId;
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 50);
    }, 50);
  };

  return (
    <header className={`header ${isScrolled ? "scrolled" : ""}`}>
      <div className="header-container">
        <div className="logo" onClick={() => scrollToSection("home")}>
          <img
            src={process.env.PUBLIC_URL + "/img/android-chrome-192x192.png"}
            alt="Alireza Adibi Logo"
            className="logo-img"
          />
          <span className="logo-text">Alireza Adibi</span>
        </div>
        <nav className="nav">
          <a
            href="#home"
            onClick={(e) => {
              e.preventDefault();
              scrollToSection("home");
            }}
          >
            {t.nav.home}
          </a>
          <a
            href="#about"
            onClick={(e) => {
              e.preventDefault();
              scrollToSection("about");
            }}
          >
            {t.nav.about}
          </a>
          <a
            href="#skills"
            onClick={(e) => {
              e.preventDefault();
              scrollToSection("skills");
            }}
          >
            {t.nav.skills}
          </a>
          {/* <a href="#projects" onClick={(e) => { e.preventDefault(); scrollToSection('projects'); }}>
            {t.nav.projects}
          </a> */}
          <a
            href="#certificates"
            onClick={(e) => {
              e.preventDefault();
              scrollToSection("certificates");
            }}
          >
            {t.nav.certificates}
          </a>
          <a
            href="#blog"
            onClick={(e) => {
              e.preventDefault();
              if (onNavigate) {
                onNavigate("blog");
              }
              window.location.hash = "blog";
              window.dispatchEvent(new HashChangeEvent("hashchange"));
            }}
          >
            {t.nav.blog}
          </a>
          <a
            href="#contact"
            onClick={(e) => {
              e.preventDefault();
              scrollToSection("contact");
            }}
          >
            {t.nav.contact}
          </a>
        </nav>
        <div className="header-controls">
          <button
            className="theme-toggle"
            onClick={toggleTheme}
            aria-label="Toggle theme"
          >
            {theme === "light" ? "🌚" : "🤍"}
          </button>
          <button
            className="language-toggle"
            onClick={toggleLanguage}
            aria-label="Toggle language"
          >
            {language === "en" ? " فا" : "🇺🇸 EN"}
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
